/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { onboardingGetInvite } from "../../funcs/onboardingGetInvite.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetOnboardingInviteRequest$inboundSchema,
};

export const tool$onboardingGetInvite: ToolDefinition<typeof args> = {
  name: "onboarding-get-invite",
  description: `Retrieve details about an onboarding invite.

To access this endpoint using an [access token](https://docs.moov.io/api/authentication/access-tokens/) 
you'll need to specify the \`/accounts.read\` scope.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await onboardingGetInvite(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value.result;

    return formatResult(value, apiCall);
  },
};
